import { Link } from 'react-router-dom';
import { featuredMovie } from '@/mocks/movies';

const META = [
  { label: '导演', value: featuredMovie.director, icon: 'ri-clapperboard-line' },
  { label: '主演', value: featuredMovie.cast.slice(0, 3).join('、'), icon: 'ri-user-star-line' },
  { label: '上映年份', value: `${featuredMovie.year} 年`, icon: 'ri-calendar-line' },
  { label: '地区', value: featuredMovie.region, icon: 'ri-earth-line' },
];

export default function SynopsisSection() {
  const movie = featuredMovie;

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-8 lg:gap-12 items-start">
        <div className="w-full max-w-[300px] mx-auto lg:mx-0">
          <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden border border-background-200">
            <img
              src={movie.cover}
              alt={`${movie.title} 电影海报`}
              title={`${movie.title} 剧情介绍`}
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-10 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
              <i className="ri-book-open-line text-xl"></i>
            </span>
            <div>
              <p className="text-xs text-foreground-500 font-label uppercase tracking-widest">Storyline</p>
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">剧情简介</h2>
            </div>
          </div>

          <p className="text-accent-700 font-medium text-sm md:text-base mb-4">{movie.tagline}</p>

          <div className="space-y-4 text-foreground-600 leading-relaxed text-sm md:text-base">
            {movie.synopsis.slice(0, 2).map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-8">
            {META.map((m) => (
              <div
                key={m.label}
                className="flex items-start gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70"
              >
                <span className="w-9 h-9 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center shrink-0">
                  <i className={m.icon}></i>
                </span>
                <div className="min-w-0">
                  <p className="text-xs text-foreground-500">{m.label}</p>
                  <p className="text-sm font-medium text-foreground-900 truncate">{m.value}</p>
                </div>
              </div>
            ))}
          </div>

          <Link
            to={`/detail/${movie.id}`}
            className="inline-flex items-center gap-2 mt-8 px-5 py-2.5 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看完整剧情与演员信息 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}